const JsFunctionTitleName = "JS Functions";

export default JsFunctionTitleName;



// WEBPACK FOOTER //
// ./src/views/Components/JsFunctions/StaticData/TitleName.tsx